__turbopack_context__.v({
  "client-header": "client-text-module-scss-module__Ktd1hW__client-header",
  "client-text": "client-text-module-scss-module__Ktd1hW__client-text",
});
